export const config = {
  defaultPageSize: 25,
  maxPageSize: 2500,
  maxPageNumberLinks: 5
};
